import { render, staticRenderFns } from "./HighlightedName.vue?vue&type=template&id=16168f9c&"
import script from "./HighlightedName.vue?vue&type=script&lang=ts&"
export * from "./HighlightedName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports